// BuzzBump Chatbot - Matching engine (100% local)
import { chatbotIntents } from '../data/chatbot-knowledge';

// Normalise le texte (lowercase, accents, ponctuation)
function normalize(text) {
  return text
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // remove accents
    .replace(/[^\w\s]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

// Score Levenshtein simplifié pour fuzzy matching court
function fuzzyIncludes(text, keyword) {
  if (text.includes(keyword)) return 1;
  // Allow 1 char tolerance for short typos on words >= 5 chars
  if (keyword.length >= 5) {
    for (let i = 0; i < keyword.length; i++) {
      const variant = keyword.slice(0, i) + keyword.slice(i + 1);
      if (text.includes(variant)) return 0.7;
    }
  }
  return 0;
}

// Calcule un score pour chaque intent et retourne le meilleur (avec confiance)
export function findBestIntent(userMessage) {
  const normalized = normalize(userMessage);
  if (!normalized) return null;

  const scores = chatbotIntents.map((intent) => {
    let score = 0;
    let matches = 0;

    intent.keywords.forEach((kw) => {
      const nk = normalize(kw);
      const s = fuzzyIncludes(normalized, nk);
      if (s > 0) {
        // Longer keyword = higher weight
        score += s * Math.min(nk.length / 4, 3);
        matches += 1;
      }
    });

    // Bonus si plusieurs mots-clés matchent
    if (matches >= 2) score *= 1.4;

    return { intent, score, matches };
  });

  scores.sort((a, b) => b.score - a.score);
  const best = scores[0];

  if (!best || best.score < 1) return null;
  return best.intent;
}

// Retourne une réponse + suggestions liées
export function getReply(userMessage) {
  const intent = findBestIntent(userMessage);

  if (!intent) {
    return {
      intentId: null,
      text: "Hmm, je ne suis pas sûr d'avoir compris 🤔. Tu peux reformuler, ou choisir une des suggestions ci-dessous ?",
      related: ['what_is', 'how_play', 'price', 'download', 'help_project', 'contact'],
    };
  }

  const text = intent.answers[Math.floor(Math.random() * intent.answers.length)];
  return {
    intentId: intent.id,
    text,
    related: intent.related || [],
  };
}

// Récupère la réponse directe via ID (utile pour les clics sur suggestions)
export function getReplyById(intentId) {
  const intent = chatbotIntents.find((i) => i.id === intentId);
  if (!intent) return null;
  const text = intent.answers[Math.floor(Math.random() * intent.answers.length)];
  return {
    intentId: intent.id,
    text,
    related: intent.related || [],
  };
}
